export default "__VITE_ASSET__DG1R2EGP__"